import { US } from '../constants/country-codes';
import { FIELD_NAMES } from './address-fields/constants';

const EDIT_ADDRESS_FIELDS = [
  FIELD_NAMES.CITY,
  FIELD_NAMES.COMPANY,
  FIELD_NAMES.COUNTRY_CODE,
  FIELD_NAMES.LINE1,
  FIELD_NAMES.LINE2,
  FIELD_NAMES.LINE3,
  FIELD_NAMES.NAME,
  FIELD_NAMES.PHONE,
  FIELD_NAMES.POSTAL_CODE,
  FIELD_NAMES.STATE,
];

// checks that any fields in the edit address form are different
export const isAddressChanged = (originalAddress, newAddress) =>
  EDIT_ADDRESS_FIELDS.some((key) => originalAddress[key] !== newAddress[key]);

// Normalizes a value for comparison: lowercases strings and treats null/undefined/empty string as equivalent
const normalizeValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  if (typeof value === 'string') {
    return value.toLowerCase().trim();
  }
  return value;
};

// Normalizes postal code for comparison (compares base ZIP for US addresses)
const normalizePostalCode = (postalCode, countryCode) => {
  const normalized = normalizeValue(postalCode);
  // For US addresses, compare only the base 5-digit ZIP (ignore ZIP+4)
  if (countryCode?.toUpperCase() === US && normalized.length >= 5) {
    return normalized.substring(0, 5);
  }
  return normalized;
};

// Fields to compare for semantic address equality (excludes verification metadata)
const ADDRESS_COMPARISON_FIELDS = [
  FIELD_NAMES.NAME,
  FIELD_NAMES.COMPANY,
  FIELD_NAMES.PHONE,
  FIELD_NAMES.LINE1,
  FIELD_NAMES.LINE2,
  FIELD_NAMES.LINE3,
  FIELD_NAMES.CITY,
  FIELD_NAMES.STATE,
  FIELD_NAMES.COUNTRY_CODE,
];

// Checks if two addresses are semantically equal (ignores case, null vs empty, ZIP+4 extension, and verification metadata)
export const areAddressesSemanticallyEqual = (address1, address2) => {
  if (!address1 && !address2) return true;
  if (!address1 || !address2) return false;

  // Compare standard fields with normalization
  const fieldsMatch = ADDRESS_COMPARISON_FIELDS.every((key) => normalizeValue(address1[key]) === normalizeValue(address2[key]));

  // Compare postal codes with special handling for ZIP+4
  const postalCodesMatch =
    normalizePostalCode(address1[FIELD_NAMES.POSTAL_CODE], address1[FIELD_NAMES.COUNTRY_CODE]) ===
    normalizePostalCode(address2[FIELD_NAMES.POSTAL_CODE], address2[FIELD_NAMES.COUNTRY_CODE]);

  return fieldsMatch && postalCodesMatch;
};
